<template>
  <div class="login">
    <ValidationObserver
      v-slot="{ invalid }"
      ref="observer"
      tag="form"
      name="userLoginForm"
      class="form"
      @submit.prevent="validateBeforeSubmit()"
    >
      <InputText
        v-model="form.mail"
        :label="'認証メールアドレス'"
        :type="'email'"
        :maxlength="255"
        rules="required|email|max:255"
        class="form__group"
      />

      <InputText
        v-model="form.password"
        :label="'パスワード'"
        :type="'password'"
        :maxlength="20"
        rules="required|min:6|max:20"
        class="form__group"
      />

      <p
        v-if="validation"
        class="form-valiTxt"
      >
        {{ validation }}
      </p>

      <!-- Submit Button -->
      <div class="form__group login__btn">
        <Btn
          :label="'ログイン'"
          :color="'red'"
          :type="'submit'"
          :disabled="isLoading"
        />

        <!-- go to register account -->
        <Btn
          :label="'新規会員登録'"
          :color="'borderRed'"
          class="mt30"
          @click.native="$router.push({ name: 'AccountCreateStep01Mail' })"
        />

        <!-- go to forget password -->
        <router-link
          :to="{ name: 'PasswordForgot' }"
          class="form-passBtn">パスワードを忘れた方
        </router-link>
        <p class="attention">
          2023/5/31以前にご登録いただいている会員様につきましては、パスワード再設定が必要です。<br>
          「パスワードを忘れた方」より再設定をお願い致します。
        </p>

        <!-- TODO: 仮設置なのでコメントアウトしておく(正式なデザインが出来たら移植する）
        <span
          class="form-passBtn"
          @click="backToEcSite()"
        >
          戻る
        </span>
        -->
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import error from '@/mixin/error.mixin'
import redirect from '@/mixin/redirect.mixin'
import InputText from '@/components/parts/InputText'
import Btn from '@/components/parts/Btn'

export default {
  name: 'Login',

  mixins: [
    // APIエラーメッセージ
    error,
    // リダイレクト ※ GETパラメータ (redirecturl, backurl)
    redirect
  ],

  components: {
    mapGetters,
    InputText,
    Btn
  },

  computed: {
    ...mapGetters(['isLoading'])
  },

  data () {
    return {
      form: {
        mail: '',
        password: ''
      },
      validation: ''
    }
  },

  beforeRouteEnter (from, to, next) {
    store.commit('loadingAction', false)
    next()
  },

  methods: {
    async validateBeforeSubmit () {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        store.commit('loadingAction', true)
        store.dispatch('auth/login', {
          mail: this.form.mail,
          password: this.form.password
        }).then(() => {
          this.goToEcSite()
        }).catch((err) => {
          store.commit('loadingAction', false)
          this.validation = this.getValidateErrorMessage(err)
        })
      }
    },

    backToEcSite () {
      this.goBackToEcSite()
    }
  }
}
</script>
<style lang="postcss" scoped>
  @import '../assets/css/common.css';
  @import '../assets/css/form.pcss';

  .login {
    margin-top: 50px;
    padding-top: 50px;
    .mt30 {
      margin-top: 30px;
    }
    &__btn {
      margin: 40px 0 34px;
    }
    & .form-passBtn {
      display: block;
      color: #7d7d7d;
      font-size: 16px;
      margin: 34px auto 0;
      text-align: center;
      line-height: 1.5;
      font-weight: bold;
      text-decoration: underline;
    }
    .attention {
      padding: 35px 12px 12px;
      color: #F00;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue